<template>
    <section>
        <div class="container-fluid mx-0">
            <div class="row">
                <div class="col-4 background text-center">
                    <div class="wrapper">
                        <img src="/static/images/logo.png" class="img-fluid mb-4"/>
                        <h3 class="text-uppercase text-white">Content Management System</h3>
                    </div>
                </div>
                <div class="col-8 px-5 content">
                    <div class="wrapper">
                        <h2 class="text-danger mb-5">
                            <span class="font-weight-bold">Log in to BTA Group</span><br />
                            <small class="font-weight-medium">Content Management System</small>
                        </h2>
                        <form v-on:submit.prevent="login">
                            <div class="form-group mb-4">
                                <label class="font-weight-bold text-danger h3">User ID</label>
                                <input type="text" v-model="form.username" class="form-control is-invalid" placeholder="User ID" required/>
                            </div>
                            <div class="form-group mb-4">
                                <label class="font-weight-bold text-danger h3">Password</label>
                                <input type="password" v-model="form.password" class="form-control is-invalid" placeholder="Password" required />
                            </div>
                            <button type="submit" class="btn btn-danger px-5">Log In</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "LoginSection",
        data() {
            return {
                form: {
                    username: '',
                    password: ''
                }
            };
        },
        methods: {
            login() {
                this.$store.dispatch('login', {user: this.form, requestOptions: {meta: {throwError: false}}}).then(response => {
                    var data = response.data;
                    if (data.status) {
                        this.$toastr('info', 'Welcome');
//                        this.$router.replace({name: 'index'});
                        location.reload();
                    } else {
                        this.form.password = '';
                        this.$toastr('warning', data.message, 'Warning');
                    }
                });
            }
        },
        mounted() {
            document.title = 'Login Page BTA Group - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .background{
        background-color: #DA1A31;
        height: 100vh;
        background-image: url(/static/images/background-login.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;   
    }
    .background .wrapper{
        letter-spacing: 0.07rem;
        position: absolute;
        top: 45%;
        transform: translateY(-50%);
    }
    .background .wrapper img{
        width: 40%;
        vertical-align: bottom;
    }
    .content .wrapper{
        width: 70%;
        position: absolute;
        top: 45%;
        transform: translateY(-50%);
    }
    .form-control { border: 1.2px solid; font-size: 1.4rem; }
    .form-control.is-invalid { border-color: #DA1A31; }
</style>


// WEBPACK FOOTER //
// src/components/authenticate/Login.vue